
(() => {
  const TOAST_MS = 3200;

  class CartStatus extends HTMLElement {
    connectedCallback() {
      this.box = this.querySelector('[data-cart-toast]') || this;
      this.timer = null;

      this.onUpdate = ({ cart, source }) => {
        this.busy(false);

        if (source === 'cart-page') return;
        this.show(this.message(cart, source), 'ok');
      };
      this.onError = ({ message }) => {
        this.busy(false);
        this.show(message || window.themeStrings?.cartError, 'err');
      };

      window.PubSub.subscribe(window.EVENTS.cartUpdate, this.onUpdate);

      window.PubSub.subscribe(window.EVENTS.cartUpdate, ({ cart }) => {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach((el) => {

          if (el === document.body || el === document.documentElement) {
            el.setAttribute('data-cart-count', cart.item_count);
            return;
          }
          el.textContent = cart.item_count;
          el.toggleAttribute('hidden', !cart.item_count);
        });
      });
      window.PubSub.subscribe(window.EVENTS.cartError, this.onError);

      document.addEventListener('cart:request', () => this.busy(true));
    }

    message(cart, source) {
      const s = window.themeStrings || {};
      if (source === 'remove') return s.cartRemoved || s.addedToCart;
      if (source === 'quantity') return s.cartUpdated || s.addedToCart;
      return s.addedToCart;
    }

    busy(on) {
      document.documentElement.classList.toggle('cart-busy', on);
    }

    show(text, kind) {
      if (!text) return;
      this.box.textContent = text;
      this.box.className = `cart-toast cart-toast--${kind} is-visible`;
      this.box.setAttribute('role', kind === 'err' ? 'alert' : 'status');
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.box.classList.remove('is-visible'), TOAST_MS);
    }
  }

  if (!customElements.get('cart-status')) customElements.define('cart-status', CartStatus);
})();
